'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssComponent = require('react-css-component');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var baseAssetsUrl = 'https://media.fantasylabs.com/assets/';
var iosAppUrl = 'https://itunes.apple.com/us/app/fantasylabs-dfs-lineup-builder/id1034983254?ct=fantasylabs&mt=8';
var androidAppUrl = 'https://play.google.com/store/apps/details?id=com.fantasylabs.fantasylabs&hl=en_US&utm_source=fantasylabs.com&utm_campaign=fantasylabs';

var css = '\n  .upsell-container {\n    padding-top: 10px;\n    margin: 0 auto;\n    width: 186px;\n  }\n  .vertical-padding {\n    padding: 10px 0;\n  }\n  .app-store-image-container {\n    display: inline;\n  }\n  .app-store-image {\n    height: 27px;\n    width: 91px;\n  }\n';

var AppUpsell = function (_PureComponent) {
    _inherits(AppUpsell, _PureComponent);

    function AppUpsell() {
        _classCallCheck(this, AppUpsell);

        return _possibleConstructorReturn(this, (AppUpsell.__proto__ || Object.getPrototypeOf(AppUpsell)).apply(this, arguments));
    }

    _createClass(AppUpsell, [{
        key: 'render',
        value: function render() {
            var phoneImage = this.props.page === 'sweatstation' ? 'images/app-icons/iphone-sweatstation@2x.png' : this.props.page === 'propositions' ? 'images/app-icons/iphone-props.png' : 'images/app-icons/iphone-articles.png';
            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(_reactCssComponent.UniversalStyle, { css: css }),
                _react2.default.createElement(
                    'div',
                    { className: 'upsell-container' },
                    _react2.default.createElement(
                        'div',
                        { className: 'bold' },
                        'Sorry, we don\'t support a mobile website.'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'vertical-padding' },
                        'Please download the app to use on your phone.'
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'div',
                            { className: 'app-store-image-container' },
                            _react2.default.createElement(
                                'a',
                                { href: iosAppUrl, target: '_blank' },
                                _react2.default.createElement('img', {
                                    alt: '',
                                    className: 'app-store-image',
                                    src: baseAssetsUrl + 'images/app-icons/apple@2x.png',
                                    style: { marginRight: 2 }
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'app-store-image-container' },
                            _react2.default.createElement(
                                'a',
                                { href: androidAppUrl, target: '_blank' },
                                _react2.default.createElement('img', {
                                    alt: '',
                                    className: 'app-store-image',
                                    src: baseAssetsUrl + 'images/app-icons/android@2x.png',
                                    style: { marginLeft: 2 }
                                })
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement('img', { alt: '', src: baseAssetsUrl + phoneImage, style: { marginTop: 10 } })
                    )
                )
            );
        }
    }]);

    return AppUpsell;
}(_react.PureComponent);

exports.default = AppUpsell;


//////////////////
// WEBPACK FOOTER
// ../component-library/build/UI/AppUpsell.js
// module id = 800
// module chunks = 0